/**
 * FE-C2g batch-6: Events / audit / activity / signals — read-path contract builders.
 */

import { buildContractPath } from "./api/contract-client.js";

export const TELEMETRY_EVENTS_TIMEOUT_MS = 16000;
export const TELEMETRY_AUDIT_TIMEOUT_MS = 24000;
export const TELEMETRY_ACTIVITY_TIMEOUT_MS = 22000;
export const TELEMETRY_SIGNALS_TIMEOUT_MS = 24000;
export const TELEMETRY_ALARMS_SUMMARY_TIMEOUT_MS = 16000;
export const TELEMETRY_OPS_MAP_SIGNALS_TIMEOUT_MS = 12000;

/** @param {URLSearchParams} sp */
export function queryFromSearchParams(sp) {
  return Object.fromEntries(sp.entries());
}

/** @param {Record<string, string | number>} [query] */
export function buildEventsPath(query) {
  return buildContractPath("get__events", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildEventsStatsByDevicePath(query) {
  return buildContractPath("get__events_stats_by-device", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildEventsStreamPath(query) {
  return buildContractPath("get__events_stream", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildEventsExportCsvPath(query) {
  return buildContractPath("get__events_export.csv", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildAuditPath(query) {
  return buildContractPath("get__audit", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildAuditExportCsvPath(query) {
  return buildContractPath("get__audit_export.csv", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildAuditExportPdfPath(query) {
  return buildContractPath("get__audit_export.pdf", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildAuditExportCoverPdfPath(query) {
  return buildContractPath("get__audit_export-cover.pdf", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildEventsExportCoverPdfPath(query) {
  return buildContractPath("get__events_export-cover.pdf", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildActivityRecordsPath(query) {
  return buildContractPath("get__activity_records", { query });
}

/** @param {Record<string, string | number>} [query] */
export function buildActivitySignalsPath(query) {
  return buildContractPath("get__activity_signals", { query });
}

export function buildAlarmsSummaryPath() {
  return buildContractPath("get__alarms_summary");
}

export function buildPostActivityScopeTokenMintPath() {
  return buildContractPath("post__activity_scope-token_mint");
}
